import styled from 'styled-components';

export const Container = styled.div`
  display: inline-flex;
  width: 100%;
  @media screen and (max-width: 800px) {
    .right-side-panel {
      display: none;
    }
  }
`;

export const LeftTopDiv = styled.div`
  height: 100%;
  width: auto;
  padding: 0 15px;
  @media screen and (max-width: 800px) {
    min-height: 450px;
  }
`;

export const LeftBottomDiv = styled.div`
  position: relative;
  background-color: white;
  margin-top: -80px;
  @media screen and (min-width: 800px) {
    margin-top: -180px;
  }
`;

export const SidePanel = styled.div`
  width: 50%;
  background-color: white;
  @media only screen and (max-width: 800px) {
    width: 100%;
    flex-direction: column;
  }
`;

export const InnerPanel = styled.div`
  display: inline-block;
  margin-left: 16.66666667%;
  width: 66.66666667%;
  height: 100%;
  background-color: white;
  @media only screen and (max-width: 800px) {
    flex-direction: column;
    margin: auto 0;
    padding: 0;
    width: 100%;
  }
`;

export const Title = styled.div`
  padding-left: 5px;
  height: 17px;
  color: #003D50;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 17px;
  margin-bottom: 10px;
`;

export const SiteRowContainer = styled.div`
  padding: 15px;
  border-radius: 5px;
  background-color: #EBF3F6;
  font-family: 'Graphik Medium', 'Graphik', sans-serif;
  @media only screen and (min-width: 800px) {
    max-height: 65vh;
    max-height: 400px;
    overflow-y: scroll;
  }
`;